"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M11.605 0a.522.522 0 0 0-.144.02L.378 3.186A.522.522 0 0 0 0 3.688v16.624c0 .233.154.438.378.502l11.083 3.166a.52.52 0 0 0 .307-.006l1.937-.554a.521.521 0 1 0-.287-1.003l-1.291.37V1.213l10.038 2.868v9.105a.522.522 0 1 0 1.043 0V3.688a.522.522 0 0 0-.378-.502L11.768.026A.522.522 0 0 0 11.605 0Zm-.522 22.787V1.213l-2.914.833v9.561a.522.522 0 0 1-.153.369l-.792.792a.522.522 0 0 1-.738 0l-.818-.819-.818.819a.522.522 0 0 1-.738 0l-.792-.792a.522.522 0 0 1-.153-.369V3.475l-2.124.607v15.836l10.04 2.869ZM4.211 3.177v8.214l.27.27.818-.819a.522.522 0 0 1 .738 0l.818.819.27-.27V2.344l-2.914.833Zm14.52 11.322a4.23 4.23 0 1 0-.13 8.459 4.23 4.23 0 0 0 .13-8.459Zm-5.272 4.228a5.272 5.272 0 1 1 10.544 0 5.272 5.272 0 0 1-10.544 0Zm8.013-1.207a.521.521 0 1 0-.738-.738l-2.797 2.797-1.214-1.214a.522.522 0 0 0-.738.738l1.583 1.583a.522.522 0 0 0 .738 0l3.166-3.166Z",
    clipRule: "evenodd"
  })]
});